import Vue from 'vue';
import VueRouter from 'vue-router';
import jwtDecode from 'jwt-decode';
import store from '../store/index';

Vue.use(VueRouter);

const routes = [
  {
    path: '/signin',
    name: 'Signin',
    meta: {
      hideForAuth: true,
    },
    component: () => import('../views/Signin.vue'),
  },
  {
    path: '/forgot',
    name: 'Forgot',
    meta: {
      hideForAuth: true,
    },
    component: () => import('../views/Forgot.vue'),
  },
  {
    path: '/reset/:token',
    name: 'Reset',
    meta: {
      hideForAuth: true,
    },
    props: true,
    component: () => import('../views/Reset.vue'),
  },
  {
    path: '/signup',
    name: 'Signup',
    meta: {
      hideForAuth: true,
    },
    component: () => import('../views/Signup.vue'),
  },
  {
    path: '/',
    name: 'Home',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/account/setup',
    name: 'AccountSetup',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/AccountSetup.vue'),
  },
  {
    path: '/fund',
    name: 'Funding',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/Funding.vue'),
  },
  {
    path: '/investments',
    name: 'Investments',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/Investments.vue'),
  },
  {
    path: '/cooperative',
    name: 'Cooperative',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/Cooperative.vue'),
  },
  {
    path: '/withdrawals',
    name: 'Withdrawals',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/Withdrawal.vue'),
  },
  {
    path: '/angel-investment',
    name: 'Angel Investment',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/AngelInvestment.vue'),
  },
  {
    path: '/investment/:trans/:id',
    name: 'Investment',
    meta: {
      requiresAuth: true,
    },
    props: true,
    component: () => import('../views/Investment.vue'),
  },
  {
    path: '/savings',
    name: 'Savings',
    meta: {
      requiresAuth: true,
    },
    props: true,
    component: () => import('../views/Savings.vue'),
  },
  {
    path: '/savings/:id/plan',
    name: 'Savings Plan',
    meta: {
      requiresAuth: true,
    },
    props: true,
    component: () => import('../views/SaveFunds.vue'),
  },
  {
    path: '/savings/:id/challenge',
    name: 'Savings Challenge',
    meta: {
      requiresAuth: true,
    },
    props: true,
    component: () => import('../views/SavingsChallenge.vue'),
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/Profile.vue'),
  },
  {
    path: '/password/update',
    name: 'Update Passsword',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/UpdatePassword.vue'),
  },
  {
    path: '/cooperative-resources',
    name: 'Cooperative Resources',
    component: () => import('../views/CooperativeResources.vue'),
  },
  {
    path: '/literacy',
    name: 'Literacy',
    meta: {
      // requiresAuth: true,
    },
    component: () => import('../components/RiskProfiles.vue'),
  },
  {
    path: '/test',
    name: 'Test',
    meta: {
      // requiresAuth: true,
    },
    component: () => import('../components/CooperativePop.vue'),
  },
  {
    path: '/goals',
    name: 'Goals',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/Goals.vue'),
  },
  {
    path: '/goals/:id',
    name: 'GoalDetails',
    meta: {
      requiresAuth: true,
    },
    props: true,
    component: () => import('../views/GoalDetails.vue'),
  },
  {
    path: '/budgets',
    name: 'Budgets',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/Budgets.vue'),
  },
  {
    path: '/budgets/:id',
    name: 'BudgetDetails',
    meta: {
      requiresAuth: true,
    },
    props: true,
    component: () => import('../views/BudgetDetails.vue'),
  },
  {
    path: '/mina-investments',
    name: 'MinaInvestment',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/MinaInvestments.vue'),
  },
  {
    path: '/resources',
    name: 'Resources',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/Resources.vue'),
  },
  // {
  //   path: '/net-worth',
  //   name: 'netWorth',
  //   meta: {
  //     requiresAuth: true,
  //   },
  //   component: () => import('../views/NetWorth.vue'),
  // },
  {
    path: '/get-started',
    name: 'Splash',
    meta: {
      getStarted: true,
    },
    component: () => import('../components/Splash.vue'),
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      const token = localStorage.getItem('token');
      const decoded = jwtDecode(token);
      const expired = decoded && new Date().getTime() > (decoded.exp * 1000);
      if (expired) {
        store.dispatch('logout');
        router.push('/signin');
      }
      next();
      return;
    }
    store.dispatch('logout');
    router.push('/signin');
  } else {
    next();
  }
  if (to.matched.some((record) => record.meta.getStarted)) {
    const getStarted = localStorage.getItem('getStarted');
    if (getStarted) {
      router.push('/');
    }
    next();
  }
  if (to.matched.some((record) => record.meta.hideForAuth)) {
    if (store.getters.isLoggedIn) {
      router.push({ path: '/' });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
